let ControllerName = 'Posts';
const PostsController = Object.freeze({
    PostById: `${ControllerName}/post-by-id`,
    FilterPosts: `${ControllerName}/filter-posts`,
    LoadMoreComments: `${ControllerName}/load-more-comments`,
    TrendingPosts: `${ControllerName}/trending-posts`,
});

export default PostsController;